import { Link2 } from "lucide-react";

interface SharedBadgeProps {
    className?: string;
}

export function SharedBadge({ className = "" }: SharedBadgeProps) {
    return (
        <div
            className={`inline-flex items-center gap-1 px-2 py-1 text-xs font-medium rounded-full border-success text-success bg-success/10 md:rotate-90 ${className}`}
        >
            <Link2 className="h-3 w-3" />
        </div>
    );
}
